import React from 'react';
import IconBoxStyle11 from '../../IconBox/IconBoxStyle11';
import Spacing from '../../Spacing';
import    { useState } from "react";
 
 

export default function ContactInfoSection({ sectionTitle }) {
  
  return (
    <div className="container">
      <h2 className="cs_fs_72 mb-0">{sectionTitle}</h2>
      <Spacing md="70" lg="50" />
      <div className="row g-4 g-xl-3 g-xxl-5">
        <div className="col-xl-4">
        <a href="tel:9825025940"> 
           <IconBoxStyle11
            title="Phone"
            subTitle="(+91)9825025940"
            iconSrc="/images/contact/icon_1.svg"
          />
          </a>
        
        </div>
        <div className="col-xl-4">
        <a href="mailto:info@mercuryhc.com"> 
          <IconBoxStyle11
            title="Email"
            subTitle="info@mercuryhc.com"
            iconSrc="/images/contact/icon_2.svg"
          />
          </a>
         
        </div>
        <div className="col-xl-4">
          <IconBoxStyle11
            title="Location"
            subTitle="44 Siddhi Industrial park, Waghodia, Gujarat, India"
            iconSrc="/images/contact/icon_3.svg"
          />
        </div>
      </div>
      <Spacing md="35" />
      {/* Start Google Map */}
      <div className="cs_map">
      {/* <iframe
  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d29532.89285960558!2d73.31785763488773!3d22.292697709308786!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fd95a0e85a761%3A0xae4a651b9a9b8b05!2sYour%20Location!5e0!3m2!1sen!2sin!4v1672726724650!5m2!1sen!2sin"
  width="100%"
  height="400"
   
  allowfullscreen=""
  loading="lazy"
></iframe> */}
<iframe
  id="map"
  title="Google Map"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31080148.134476315!2d73.31785763488773!3d22.292697709308786!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fd95a0e85a761%3A0xae4a651b9a9b8b05!2sMercury%20Healthcare%20-%20Hyper-Hypothermia%20unit%2C%20Sternum%20Saw%2C%20Mercury%20Mini%2C%20Manufacturer%20%26%20Supplier!5e0!3m2!1sen!2sin!4v1723632324650!5m2!1sen!2sin"
  allowfullscreen
   
></iframe>

  

      </div>
      {/* End Google Map */}
      
    </div>
  );
}
 